import { useCallback, useEffect, useState } from 'react';
import debounce from 'lodash/debounce';

type Dimensions = {
  width: number;
  height: number;
};

const useWindowDimensions = () => {
  const [dimensions, setDimensions] = useState<Dimensions>({
    width: 0,
    height: 0,
  });

  const updateDimensions = () => {
    setDimensions({
      height: window.innerHeight,
      width: window.innerWidth,
    });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleResize = useCallback(debounce(updateDimensions, 1000), []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', handleResize);

      updateDimensions();

      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, []);

  return {
    dimensions,
  };
};

export default useWindowDimensions;
